function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
import React, { PureComponent, Fragment, useContext } from "react";
import { ThemeProvider } from "styled-components";
import mergeDeep from "../../utils/merge-deep";
import GlobalStyle from "../global-style";
import { createBrowserHistory, createHashHistory, createMemoryHistory } from "history";
import unionBy from "lodash/unionBy";
import defaultCtx from "./default-ctx";
import { standardTheme } from "./index";
export var WrContext = function() {
    throw new Error("Using WrContext without setting up configureContext first");
};
export var WrContextProvider;
export var WrContextConsumer;
export var context = defaultCtx;
export var updateContextState = function updateContextState(updater, callback) {
    if (process.env.NODE_ENV !== "production" && process.env.REACT_APP_WR_TEST !== "true") {
        console.time("updateContext");
    }
    if (!callback) {
        callback = function() {};
    }
    updater(context.state);
    this.setState({
        context: _objectSpread({}, context)
    }, callback);
    if (process.env.NODE_ENV !== "production") {
        console.timeEnd("updateContext");
    }
};
var createContextProvider = function(context) {
    var comp = /*#__PURE__*/ function(PureComponent) {
        "use strict";
        _inherits(_class, PureComponent);
        var _super = _createSuper(_class);
        function _class(props) {
            _classCallCheck(this, _class);
            var _this;
            _this = _super.call(this, props);
            _this.state = {
                context: _objectSpread({}, context)
            };
            updateContextState = updateContextState.bind(_assertThisInitialized(_this));
            return _this;
        }
        var _proto = _class.prototype;
        _proto.render = function render() {
            return /*#__PURE__*/ React.createElement(WrContext.Provider, {
                value: this.state.context
            }, /*#__PURE__*/ React.createElement(ThemeProvider, {
                theme: this.state.context.theme
            }, /*#__PURE__*/ React.createElement(Fragment, null, /*#__PURE__*/ React.createElement(GlobalStyle, null), this.props.children)));
        };
        return _class;
    }(PureComponent);
    return comp;
};
var reduceRoute = function(route) {
    return [
        _defineProperty({}, route.key, route.path), 
    ].concat(_toConsumableArray(((route === null || route === void 0 ? void 0 : route.routes) || []).reduce(function(acc, r) {
        return reduceRoute(r);
    }, [])));
};
var createGetRoute = function(routes) {
    // Convert the routes into a flat object of { key: path }
    var routeMappings = routes.reduce(function(acc, route) {
        return _toConsumableArray(acc).concat(_toConsumableArray(reduceRoute(route)));
    }, []).reduce(function(acc, route) {
        return _objectSpread({}, acc, route);
    }, {});
    var paramRe = /\/:\w+\??/g;
    return function(key, replacements) {
        var path = routeMappings[key];
        if (!path) {
            return "";
        }
        // Apply any replacements
        if (replacements) {
            Object.entries(replacements).forEach(function(param) {
                var _param = _slicedToArray(param, 2), k = _param[0], v = _param[1];
                path = path.replace(":" + k, v);
            });
        }
        // Remove any remaining replacements that were not passed in
        path = path.replace(paramRe, "");
        return path;
    };
};
var combineRoutes = function(r1, r2) {
    return unionBy(r2, r1, "key");
};
export var configureContext = function(ctx) {
    var ref;
    var combinedRoutes = combineRoutes(context.routes, ctx.routes || []);
    if (!ctx.theme) ctx.theme = standardTheme;
    mergeDeep(context, ctx);
    context.routes = combinedRoutes;
    context.getRoutePath = createGetRoute(context.routes);
    context.pushRoute = function(key, replacements) {
        return context.history.push(context.getRoutePath(key, replacements));
    };
    if (ctx.memoryHistory) {
        context.history = createMemoryHistory();
    } else if (ctx.hashHistory) {
        context.history = createHashHistory();
    } else {
        context.history = createBrowserHistory();
    }
    var externalUserToken = context.persistentStorage.get(context.constants.sso.tokenStorageKey);
    // Check for user token from LocalStorage
    var userToken = context.persistentStorage.get("token") || externalUserToken;
    if (userToken) {
        try {
            var tokenData = JSON.parse(window.atob(userToken.split(".")[1]));
            if (tokenData.externalUser) {
                context.state.user = {
                    id: tokenData.id,
                    externalUser: tokenData.externalUser,
                    externalId: tokenData.externalId
                };
                context.state.isLoginResolving = true;
            } else if (tokenData.id) {
                context.state.user = {
                    id: tokenData.id,
                    email: tokenData.email
                };
                context.state.isLoggedIn = true;
            }
            context.state.authorization = userToken;
        // Get a new token to extend its expiry
        // refreshToken(userToken)
        } catch (e) {}
    }
    if (externalUserToken && typeof context.constants.sso.onAuthResolved === "function") {
        context.constants.sso.onAuthResolved({
            authorization: externalUserToken,
            user: context.state.user
        });
    }
    if ((ref = ctx.constants) === null || ref === void 0 ? void 0 : ref.requireAuth) {
        ctx.constants.token = "";
    }
    if (context.state.workflow) {
        context.state.workflow.startResyncListener(context);
    }
    WrContext = /*#__PURE__*/ React.createContext(context);
    WrContextProvider = createContextProvider(context);
    WrContextConsumer = WrContext.Consumer;
};
export var withContext = function(Component) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return function(props) {
        return /*#__PURE__*/ React.createElement(WrContextConsumer, null, function(context) {
            var passedProps = options.mapProps ? options.mapProps(context, props) : {
                context: context
            };
            return /*#__PURE__*/ React.createElement(Component, _extends({}, props, passedProps));
        });
    };
};
export var useWrContext = function() {
    var ctx = useContext(WrContext);
    return ctx;
};
